// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
export type PathwayCardFragment = (
  { __typename?: 'PathwayModelAsStudent' }
  & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'currentTopicVersionsCount'>
  & { coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
  )>, coverImageVariants: Array<(
    { __typename?: 'ImageVariantModel' }
    & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'size_key'>
  )>, tags: Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>, currentEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'PathwayEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.PathwayEnrolmentModelAsStudent, 'id' | 'completed_at' | 'target_date' | 'progress' | 'status' | 'completed_status'>
  )> }
);

export const PathwayCardFragmentDoc = gql`
    fragment PathwayCard on PathwayModelAsStudent {
  id
  title
  currentTopicVersionsCount
  coverImage {
    id
    cdnUrl
  }
  coverImageVariants {
    cdnUrl
    size_key
  }
  tags {
    id
    name
  }
  currentEnrolment {
    id
    completed_at
    target_date
    progress
    status
    completed_status
  }
}
    `;